import React, { useContext, useState, useEffect, useRef } from "react";
import { AuthContext } from "store/AuthProvider";
import { StoreContext } from "store/StoreProvider";
import { PickemLayoutPage } from "layouts/PickemLayoutPage";
import { PickemPicksTable } from "components/common/Table/PickemPicksTable";
import { headListFootball, adminHeadListFootball, headListBasketball, adminHeadListBasketball, headListBaseball, adminHeadListBaseball, headListHockey, adminHeadListHockey } from "./model";
//import { Breadcrumbs } from "components/common/Breadcrumbs";
import { NoResults } from "components/common/NoResults";
import { Spinner } from "components/common/Spinner/Spinner";
import { withDialog } from "components/common/withDialog/withDialog";
import { PickemTextInput } from "components/common/Form/TextInput/TextInput";
import PickemCheckbox from "components/common/Form/Checkbox/PickemCheckbox";
import { Select } from "components/common/Form/Select/Select";
//import { Select } from "components/common/Form/Select/Select";
import Confirmation from "modals/Confirmation";
import { simpleOptions, options } from "utils/helpers";
import "./PickemPicksPage.scss";
import moment from "moment";
//const CryptoJS = require("crypto-js");

//GetPickset -> know competitor, competition, currentWeek, regular weeks + postseason weeks to build the page

const Tiebreakers = ({ tiebreakers, handleTiebreakerInput, tiebreakData }) => {
    return tiebreakData ? (
        <div className="PickemPicksPage-tiebreakers">
        <h2>Tiebreakers</h2>
        <table>
            <tbody>
                {tiebreakData.map((item, i) => {
                    return (<tr key={`tiebreaker-${i}`} className="PickemPicksPage-tiebreakerRow">
                    <td className="PickemPicksPage-tiebreakerTdRight"> 
                        {item.awayTeam}
                    </td>
                    <td className="PickemPicksPage-tiebreakerInput">
                        <input
                            type="text"
                            title= {`Tiebreaker ${i} Away Score`}
                            value= {tiebreakers[`away${i}`] || ""}
                            code={`tiebreak${i}away`}
                            name={`away${i}`}
                            onChange={handleTiebreakerInput}
                            className="PickemPicksPage-tiebreakerInput"
                        />
                    </td>
                    <td className="PickemPicksPage-tiebreakerTd">
                        @
                    </td>
                    <td className="PickemPicksPage-tiebreakerInput">
                    <input
                            type="text"
                            title= {`Tiebreaker ${i} Home Score`}
                            value= {tiebreakers[`home${i}`] || ""}
                            code={`tiebreak${i}home`}
                            name={`home${i}`}
                            onChange={handleTiebreakerInput}
                            className="PickemPicksPage-tiebreakerInput"
                        />
                    </td >
                    
                    <td className="PickemPicksPage-tiebreakerTdLeft">
                        {item.homeTeam}
                    </td>

                </tr>)

                })}
            </tbody>
        </table>
        </div>
    ) : null
}

const PickemPicksPage = ({
    history, openModal, closeModal,
    match: {
        params: {
            competitionId
        }
    }
    }) => {
    const { functions, accountData, user } = useContext(AuthContext);
    const { updateMeta, competitionData, updateCompetitionData, version } = useContext(StoreContext);
    const [userPickset, setUserPickset] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [isPickLoading, setIsPickLoading] = useState(true)
    const [currentWeek, setCurrentWeek] = useState(null);
    const [selectedWeek, setSelectedWeek] = useState(null);
    const [selection, setSelection] = useState({})
    const [isSelectedLoading, setIsSelectedLoading] = useState(true)
    const [initialEventData, setInitialEventData] = useState({})
    const [nameString, setNameString] = useState(null)
    const [competitionName, setCompetitionName] = useState(null)
    const [competitionDescription, setCompetitionDescription] = useState(null)
    const [errorLoadingPicks, setErrorLoadingPicks] = useState(false)
    const [isSavingPicks, setIsSavingPicks] = useState(false)
    const [initialSelection, setInitialSelection] = useState({})
    const [isSaveEnabled, setIsSaveEnabled] = useState(false)
    const [tiebreakers, setTiebreakers] = useState({})
    const [tiebreakData, setTiebreakData] = useState(null)
    const [initialTiebreakData, setInitialTiebreakData] = useState(null)
    const [tiebreakDataLoading, setTieBreakDataLoading] = useState(true)
    const [initialTiebreakers, setInitialTiebreakers] = useState({})
    const [isCommissioner, setIsCommissioner] = useState(false)
    const [hiddenEvents, setHiddenEvents] = useState({})
    const [hiddenEventsLoading, setHiddenEventsLoading] = useState(true)
    const [initialHiddenEvents, setInitialHiddenEvents] = useState({})
    const [editEvents, setEditEvents] = useState({})
    const [closingLines, setClosingLines] = useState({})
    const [outcomes, setOutcomes] = useState({})
    const [initialClosingLines, setInitialClosingLines] = useState({})
    const [statusString, setStatusString] = useState(null)
    const [deadline, setDeadline] = useState(null)
    const [competitionType, setCompetitionType] = useState(null)
    const [headList, setHeadList] = useState(null)
    const [headListLoading, setHeadListLoading] = useState(true)
    let editableKeyToFocus = useRef(null);
    const [width, setWidth] = useState(window.innerWidth);
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        if (version.isUpdated) {
            confirm("VersionChange")
        }
    }, [version])

    const confirm = (action, compId, compName) => {
        let message = '';
        let title = ''
        switch (action) {
            case 'VersionChange':
                title = 'Updated App Version'
                message = "Refresh Now"
                break
            default:
                title = "Error"
                message = "An Error Has Occurred"
                break
        }
        openModal({
            title: title,
            content: (
                <Confirmation
                    message={message}
                    closeModal={closeModal}
                    buttons={false}
                    onConfirm={() => {
                        closeModal();
                            switch (action) {
                                case 'VersionChange':
                                    window.location.reload()
                                    break
                            }
                    }}
                />
            ),
        });
    };

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    useEffect(() => {
        setIsMobile(width <= 991)
    }, [width])

    useEffect(() => {
        updateMeta({
            title: "Picks",
        });
    }, []);

    useEffect(() => {
        let name = ""
        if (competitionData.name) {
            name = competitionData.name
        }
        else {
            if (accountData.firstName && accountData.lastName) {
                name = `${accountData.firstName} ${accountData.lastName}`
            }
            else if (accountData.firstName) {
                name = `${accountData.firstName}`
            }
            else if (accountData.lastName) {
                name = `${accountData.lastName}`
            }
            else if (user.email) {
                name = `${user.email}`
            }
        }
        setNameString(name)
        if (competitionData.competitionDescription) {
            setCompetitionDescription(competitionData.competitionDescription)
        }
        if (competitionData.competitionName) {
            setCompetitionName(competitionData.competitionName)
        }
        setIsCommissioner(competitionData.isCommissioner === user.uid)
        getPickset(currentWeek)
        setIsLoading(true)
        setIsPickLoading(true)
    }, [competitionData])

    useEffect(() => {
        getPickset(currentWeek)
    }, [])

    useEffect(() => {
        setIsPickLoading(false)
    }, [userPickset])

    useEffect(() => {
        setTieBreakDataLoading(false)
    }, [tiebreakData])

    useEffect(() => {
        setHiddenEventsLoading(false)
    }, [hiddenEvents])

    useEffect(() => {
        if (competitionType) {
            determineHeadlist()
        }
    }, [competitionType])

    useEffect(() => {
        setIsSelectedLoading(false)
        analyzeUserPickset()
    }, [selection, initialEventData, initialHiddenEvents, tiebreakers, hiddenEvents, closingLines, editEvents, isSaveEnabled, isCommissioner, tiebreakData])

    const getPickset = (weekNumber) => {
        const userId = competitionData.picksUserId ? competitionData.picksUserId : user.uid
        functions.httpsCallable('pickemGetPickset')({
            body: JSON.stringify({
                competitionId: competitionId,
                userId: userId,
                isRandomUser: competitionData.isRandomUser,
                currentWeek: weekNumber
            })
        }).then((result) => {
            
            if (result.data.success) {
                setIsLoading(false)
                setIsSelectedLoading(true)
                addUserPicks({...result.data.data.eventData})
                setTiebreakData(() => ([...result.data.data.tiebreakers]))
                setInitialTiebreakData(() => ([...result.data.data.tiebreakers]))
                setInitialEventData(() => ({...result.data.data.eventData}))
                setInitialTiebreakers(() => ({...result.data.data.userTiebreakerPicks}))
                setInitialHiddenEvents(() => ({...result.data.data.hiddenEvents}))
                setHiddenEvents(() => ({...result.data.data.hiddenEvents}))
                setInitialClosingLines(() => ({...result.data.data.closingLines}))
                setClosingLines(() => ({...result.data.data.closingLines}))
                setTiebreakers(() => ({...result.data.data.userTiebreakerPicks}))
                setDeadline(result.data.data.deadline)
                setCompetitionType(result.data.data.competitionType)
                if (!weekNumber) {
                    setCurrentWeek(result.data.data.currentWeek) 
                }
                setIsLoading(false)
            } else {
                if (result.data.message === "Competitor not in competition") {
                    history.push(`/pickem-join/${competitionId}`)
                }
                setIsLoading(false)
                setIsSelectedLoading(false)
                setErrorLoadingPicks(true)
            }
        })
    }

    const addUserPicks = (userData) => {
        if (userData.currentWeek) {
            const selectedInfo = {}
            for (const pick of userData.currentWeek) {
                selectedInfo[pick.eventId] = pick.userPick
            }
            setSelection(() => ({...selectedInfo}))
            setInitialSelection(() => ({...selectedInfo}))
        }
        
    }

    const handleRadioChange = (
        value, eventId, eventLocked
    ) => {
        console.log("Event Locked:", eventLocked)
        if (Object.keys(selection).length > 0) {
            if (!eventLocked && (competitionData.picksUserId === user.uid || isCommissioner)) {
                setSelection((prevSelect) => ({
                    ...prevSelect,
                    [eventId]: value
                }))
            }
        }
    };

    const handleHideEventCheck = (eventId) => {
        let hiddenEventsNew = {...hiddenEvents}
        if (hiddenEventsNew[eventId]) {
            hiddenEventsNew[eventId] = !hiddenEventsNew[eventId]
        }
        else {
            hiddenEventsNew[eventId] = true
        }

        setHiddenEvents({...hiddenEventsNew })
    }

    const handleEditEventCheck = (eventId) => {
        let editEventsNew = {...editEvents}
        if (editEventsNew[eventId]) {
            editEventsNew[eventId] = !editEventsNew[eventId]
        }
        else {
            editEventsNew[eventId] = true
        }

        setEditEvents({...editEventsNew })
    }

    const handleTiebreakerDataChecked = (eventId) => {
        if (eventId !== tiebreakData[0].eventId) {
            const newTiebreakData = []
            const eventInfo = initialEventData.currentWeek.filter((item) => item.eventId === eventId)
            newTiebreakData.push(eventInfo[0])
            newTiebreakData.push(tiebreakData[0])
            setTiebreakData(newTiebreakData)
        }
    }

    const setClosingLine = (lineData) => {
        editableKeyToFocus.current = lineData.target.name
        if (lineData.target.value === "") {
            let closingLinesNew = {...closingLines}
            closingLinesNew[lineData.target.name] = ""
            setClosingLines({...closingLinesNew })
        }
        else {
            let closingLinesNew = {...closingLines}
            let rx = new RegExp(/^\d*\.?\d*$/);
            if (rx.test(lineData.target.value)) {
                
                closingLinesNew[lineData.target.name] = lineData.target.value
                setClosingLines({...closingLinesNew })
            }
            const saveEnabled = closingLinesNew[lineData.target.name] !== initialClosingLines[lineData.target.name]
            setIsSaveEnabled(true)
        }
        
    }

    const analyzeUserPickset = () => {
        if (initialEventData.currentWeek) {
            let saveEnabled = false
            const userPicksetData = {
                currentWeek: [],
                regWeeks: initialEventData.regWeeks,
                postWeeks: initialEventData.postWeeks
            }
            const showPicks = isCommissioner || competitionData.picksUserId === user.uid || (selectedWeek ? selectedWeek < currentWeek : false)
            
            let totalPoints = 0
            let totalPicks = 0
            let possiblePicks = 0
            let deadlineTime = 0
            let deadlineType = "None"
            if (deadline === "5 minutes before each event start time") {
                deadlineTime = 300
                deadlineType = "all"
            }
            else if (deadline ===  "5 minutes before first event start time") {
                deadlineTime = 300
                deadlineType = "first"
            } else if (deadline === "1 Hour before each event start time") {
                deadlineTime = 3600
                deadlineType = "all"
            }

            let eventCount = 0

            
            const time = new Date();
            const timeZone = moment.tz.guess();
            //current time in timezone & convert event start time to the same zone
            const currentTime = Math.floor(time.getTime() / 1000);
            
            let allEventsLocked = false
            //console.log("Analyze Picks Current Data:", currentData)
            for (const event of initialEventData.currentWeek) {
                let eventLocked = false
                eventCount += 1
                if (!isCommissioner && hiddenEvents[event.eventId]) {
                    continue;
                }

                if (event?.status && event.status === "canceled") {
                    continue;
                }
                const eventTime = moment.tz(event.startAtTimestamp, timeZone).unix()*1000
            
                if (eventCount === 1 && deadlineType === "first" && !isCommissioner) {
                    eventLocked = (eventTime - deadlineTime) < currentTime
                    allEventsLocked = eventLocked
                } else if (deadlineType === "first" && !isCommissioner && allEventsLocked) { 
                    eventLocked = true
                } else if (deadlineType === "all" && !isCommissioner) {
                    eventLocked = (eventTime - deadlineTime) < currentTime
                }

                if (!hiddenEvents[event.eventId]) {
                    possiblePicks += 1
                    totalPicks += initialSelection[event.eventId] ? 1 : 0
                }

                if (!saveEnabled)
                    saveEnabled = selection[event.eventId] !== initialSelection[event.eventId]
                console.log("Event:", selection[event.eventId], event.favorite)
                const favoritePicked = (<div><input
                    type="radio"
                    id="favorite"
                    key={`${event.eventId}-favorite`}
                    value={event.favorite}
                    checked={
                        showPicks ? selection[event.eventId] === event.favorite : false
                    }
                    onChange={() =>
                        handleRadioChange(
                            event.favorite, event.eventId, eventLocked
                        )
                    }
                /></div>)
                const vs = "vs"
                const underdogPicked = (<div><input
                    type="radio"
                    id="underdog"
                    key={`${event.eventId}-underdog`}
                    value={event.underdog}
                    checked={
                        showPicks ? selection[event.eventId] === event.underdog : false
                    }
                    onChange={() =>
                        handleRadioChange(
                            event.underdog, event.eventId, eventLocked
                        )
                    }
                /></div>)
                let final = parseFloat(closingLines[event.eventId]) || Math.abs(parseFloat(event.final))
                final = final ? final.toLocaleString("en", { minimumFractionDigits: 1 }) : final

                if (!saveEnabled) {
                    if (initialClosingLines[event.eventId] && closingLines[event.eventId]) {
                        saveEnabled = initialClosingLines[event.eventId] !== closingLines[event.eventId]
                    }
                    else if (closingLines[event.eventId]) {
                        saveEnabled = parseFloat(closingLines[event.eventId]).toLocaleString("en", { minimumFractionDigits: 1 }) !== Math.abs(parseFloat(event.final)).toLocaleString("en", { minimumFractionDigits: 1 })
                    }
                }

                let userPickObj = {
                    ...event,
                    underdogPicked: underdogPicked,
                    vs: vs,
                    favoritePicked: favoritePicked,
                    id: event.eventId,
                    final: final
                }

                switch(event?.pickOutcome) {
                    case "winning":
                        userPickObj.pickOutcome = (<img src="/images/winningIcon.png" style={{marginLeft: "0.25em", height:"2em", width:"3em"}} alt="winning" />)
                        break;
                    case "win":
                        userPickObj.pickOutcome = (<img src="/images/wonIcon.png" style={{marginLeft: "0.25em", height:"2em", width:"3em"}} alt="won" />)
                        break;
                    case "losing":
                        userPickObj.pickOutcome = (<img src="/images/losingIcon.png" style={{marginLeft: "0.25em", height:"2em", width:"3em"}} alt="losing" />)
                        break;
                    case "loss":
                        userPickObj.pickOutcome = (<img src="/images/lostIcon.png" style={{marginLeft: "0.25em", height:"2em", width:"3em"}} alt="lost" />)
                        break;
                    case "pushing":
                        userPickObj.pickOutcome = (<img src="/images/tiedIcon.png" style={{marginLeft: "0.25em", height:"2em", width:"3em"}} alt="pushing" />)
                        break;
                    case "push":
                        userPickObj.pickOutcome = (<img src="/images/pushButtonIcon.png" style={{marginLeft: "0.25em", height:"2em", width:"3em"}} alt="push" />)
                        break;
                    default:
                        userPickObj.pickOutcome = "-"
                        break;
                }

                if (isCommissioner) {
                    const hideEventButton = (
                        <div className="PickemPicksPage-hideEventDiv">
                            <PickemCheckbox
                            inputData={{
                                id: event.eventId,
                                checked: hiddenEvents[event.eventId],
                                value: event.eventId,
                                }}
                                onChange={handleHideEventCheck}
                            />
                        </div>
                    )

                    const editEventButton = (
                        <div className="PickemPicksPage-hideEventDiv">
                            <PickemCheckbox
                            inputData={{
                                checked: editEvents[event.eventId],
                                value: event.eventId,
                                id: `${event.eventId}-edit`
                                }}
                                onChange={handleEditEventCheck}
                            />
                        </div>
                    )
                    //const tiebreakerList = tiebreakData.map((item) => item.eventId)
                    const isTiebreaker = tiebreakData.filter((e) => e.eventId === event.eventId)     

                    const editTiebreakersButton = (
                        <div className="PickemPicksPage-hideEventDiv">
                            <PickemCheckbox
                            inputData={{
                                checked: isTiebreaker.length > 0 ? true : false,
                                value: event.eventId,
                                id: `${event.eventId}-tiebreak`
                                }}
                                onChange={handleTiebreakerDataChecked}
                            />
                        </div>
                    )

                    const commissionerFinal = (
                        <div className="PickemPicksPage-hideEventDiv">
                            <PickemTextInput
                                inputData={{
                                    placeholder: "",
                                    value: closingLines[event.eventId] || closingLines[event.eventId] === "" ? closingLines[event.eventId] : final ? final : "",
                                    type: "text",
                                    name: event.eventId,
                                    autoFocus: event.eventId === editableKeyToFocus.current,
                                    onFocus: (e)=>(e.selectionStart = e.target.value.length),
                                    readOnly: editEvents[event.eventId] ? null : "readOnly",
                                    style: {textAlign: 'right', width: '5em'},
                                    
                                }}
                                id={`${event.eventId}-linesBox`}
                                code="name"
                                onChange={setClosingLine}
                            />
                        </div>
                    )

                    userPickObj = {
                        ...userPickObj,
                        hide: hideEventButton,
                        edit: editEventButton,
                        final: editEvents[event.eventId] ? commissionerFinal : final,
                        tiebreaker: editTiebreakersButton
                    }
                }
                totalPoints += event.point
                userPicksetData.currentWeek.push(userPickObj)
            }
            const totalObj = {
                pickOutcome: " ",
                favorite: " ",
                favoritePicked: " ",
                vs: " ",
                underdogPicked: " ",
                underdog: " ",
                open: " ",
                line1: " ",
                line2: " ",
                line3: " ",
                final: " ",
                startAt: "TOTAL POINTS",
                point: totalPoints,
                status: "scheduled"
            }

            userPicksetData.currentWeek.push(totalObj)
            for (const key of Object.keys(tiebreakers)) {
                if (!saveEnabled)
                    saveEnabled = initialTiebreakers[key] !== tiebreakers[key]
            }
            let tiebreakersPossible = 0
            let tiebreakersPicked = 0
            for (let i = 0; i < tiebreakData.length; i++) {
                tiebreakersPossible += 1
                tiebreakersPicked += tiebreakers[`home${i}`] && tiebreakers[`away${i}`] ? 1 : 0
            }

            for (const key of Object.keys(hiddenEvents)) {
                if (Object.keys(initialHiddenEvents) > 0) {
                    if (!saveEnabled)
                        saveEnabled = initialHiddenEvents[key] !== hiddenEvents[key]
                }
                else {
                    if (!saveEnabled)
                        saveEnabled = hiddenEvents[key]
                }
            }

            for (let i = 0; i < tiebreakData.length; i++) {
                if (!saveEnabled) {
                    saveEnabled = initialTiebreakData[i].eventId !== tiebreakData[i].eventId
                }
            }
            const status = `Picks Saved: ${totalPicks} of ${possiblePicks}, Tiebreakers Saved: ${tiebreakersPicked} of ${tiebreakersPossible}`
            setStatusString(status)
            setIsSaveEnabled(saveEnabled)
            setUserPickset(userPicksetData)
        }
        
    }

    const weekClicked = (weekData) => {
        getPickset(weekData.e.target.value)
        setSelectedWeek(weekData.e.target.value)
        setIsPickLoading(true)
    }

    const createWeeks = (numWeeks, isPost) => {
        const weekList = []
        const selected = {}
        for (let weekNumber = 1; weekNumber <= numWeeks; weekNumber++) {
            const weekId = isPost ? weekNumber + userPickset.regWeeks : weekNumber
            const isCurrentWeek = currentWeek === weekId
            selected[weekId] = isCurrentWeek
            //weekList.push((<div key={weekNumber} onClick={weekClicked} className={`col PickemPicksPage-weeks ${isCurrentWeek ? "PickemPicksPage-selected": null}`}><p>{weekNumber}</p></div>))
            weekList.push((<button key={weekId} value={weekId} onClick={e => weekClicked({e, isPost}, "value")} className={`PickemPicksPage-weekButton ${isCurrentWeek ? "PickemPicksPage-currentWeek": "PickemPicksPage-notCurrentWeek"} ${Number(selectedWeek) === weekId ? "PickemPicksPage-selectedWeek": null}`}>{weekNumber}</button>))
        }
        return weekList
    }

    const handleSavePicks = () => {
        const userId = competitionData.picksUserId ? competitionData.picksUserId : user.uid
        let updateAllStandings = false
        for (const key of Object.keys(closingLines)) {
            if (closingLines[key] === "") {
                closingLines[key] = "0.0"
            }
            else {
                closingLines[key] = parseFloat(closingLines[key]).toLocaleString("en", { minimumFractionDigits: 1 })
            }
        }
        const hiddenList = Object.keys(hiddenEvents).filter((key) => hiddenEvents[key])
        const newTiebreakList = []
        for (let i = 0; i < tiebreakData.length; i++) {
            if (tiebreakData[i].eventId !== initialTiebreakData[i].eventId) {
                newTiebreakList.push(tiebreakData[i].eventId)
            }
        }
        for (const key of Object.keys(closingLines)) {
            if (closingLines[key] !== initialClosingLines[key]) {
                updateAllStandings = true
            }
        }
        for (const key of Object.keys(hiddenEvents)) {
            if (hiddenEvents[key] !== initialHiddenEvents[key]) {
                updateAllStandings = true
            }
        }
        if (newTiebreakList.length > 0) {
            updateAllStandings = true
        }
        const savePicksetObj = {
            competitionId: competitionId,
            currentWeek: selectedWeek || currentWeek,
            pickData: selection,
            tiebreakers: tiebreakers,
            isRandomUser: competitionData.isRandomUser,
            hiddenEvents: hiddenList,
            closingLines: closingLines,
            tiebreakData: newTiebreakList,
            userId: userId,
            isCommissioner: isCommissioner
        }

        setIsSavingPicks(true)
        functions.httpsCallable('pickemSavePickset')({
            body: JSON.stringify({...savePicksetObj})
        }).then((result) => {
            setIsSavingPicks(false)
            setIsSaveEnabled(false)
            if (result.data.success) {
                if (updateAllStandings) {
                    functions.httpsCallable('pickemGetStandingsPage')({
                        body: JSON.stringify({
                            competitionId: competitionId,
                            runAllWeeks: true,
                            currentWeek: null,
                            onlyUpdateStandings: true
                        })
                    })
                    getPickset(selectedWeek || currentWeek)
                } else {
                    setInitialSelection(selection)
                    getPickset(selectedWeek || currentWeek)
                }
                
            }
        }) 

    }

    const handleTiebreakerInput = (e) => {
        const tiebreakerUpdate = {}
        tiebreakerUpdate[`${e.target.name}`] = e.target.value
        setTiebreakers(current => ({
            ...current,
            ...tiebreakerUpdate
        }))

    }

    const handleCancelPicks = () => {
        addUserPicks({...initialEventData})
        setTiebreakers({...initialTiebreakers})
        setHiddenEvents({...initialHiddenEvents})
        setTiebreakData([...initialTiebreakData])
    }



    const SaveButton = () => {
        return (
            <button style={{ fontSize: "1em", margin: "0.5em" }}
            className={`btn-primary ${!isSaveEnabled ? "PickemPicksPage-disabled" : null}`} onClick={handleSavePicks} disabled={!isSaveEnabled}
        >
            Save
        </button>
        )
    }

    const CancelButton = () => {
       return ( <button style={{ fontSize: "1em", margin: "0.5em" }}
            className={`btn-secondary ${!isSaveEnabled ? "PickemPicksPage-disabled" : null}`} onClick={handleCancelPicks} disabled={!isSaveEnabled}
        >
            Cancel
        </button>
       )
    }

    const StatusBar = () => {
        return (!isLoading && !isSavingPicks && statusString ? <div className="PickemPicksPage-statusBar"><p>{statusString}</p></div> : null)
    }

    const determineHeadlist = () => {
        if (competitionType) {
            switch(competitionType) {
                case "Pro Football":
                case "College Football":
                case "Pro & College Football":
                    if (isCommissioner) {
                        setHeadList(adminHeadListFootball)
                        setHeadListLoading(false)
                        break;
                    } else {
                        setHeadList(headListFootball)
                        setHeadListLoading(false)
                        break;
                    }
                case "Basketball":
                case "College Basketball":
                    if (isCommissioner) {
                        setHeadList(adminHeadListBasketball)
                        setHeadListLoading(false)
                        break;
                    } else {
                        setHeadList(headListBasketball)
                        setHeadListLoading(false)
                        break;
                    }
                case "Hockey":
                    if (isCommissioner) {
                        setHeadList(adminHeadListHockey)
                        setHeadListLoading(false)
                        break;
                    } else {
                        setHeadList(headListHockey)
                        setHeadListLoading(false)
                        break;
                    }
                case "Baseball":
                    if (isCommissioner) {
                        setHeadList(adminHeadListBaseball)
                        setHeadListLoading(false)
                        break;
                    } else {
                        setHeadList(headListBaseball)
                        setHeadListLoading(false)
                        break;
                    }
                
            }
        }
       
    }

    return (
        <PickemLayoutPage
            title={`${competitionData.shownPicksetName.length > 0 ? competitionData.shownPicksetName : competitionData.userPicksetName} Picks`}
            name={nameString} 
            competitionName={competitionName} 
            competitionDescription={competitionDescription}
            isDifferentUser={competitionData.picksUserId ? competitionData.picksUserId !== user.uid : false}
            subtitle={
                <>
                    {
                        <div className={isMobile ? "PickemPicksPage-mobileHeader" : null} style={{ display: "flex", fontSize: "1em", justifyContent: "flex-end"}}>
                                <SaveButton />
                                <CancelButton /> 
                        </div>
                    }
                </>
            }
        >
            <div className="PickemPicksPage">
            <div className="PickemPicksPage-weekView">
                {!isLoading && userPickset.regWeeks ? <div className="PickemPicksPage-weeks">
                        <div><p>Regular</p></div>
                        {
                            createWeeks(userPickset.regWeeks, false)
                        }
                </div> : null}
                {!isLoading && userPickset.postWeeks ? <div className="PickemPicksPage-weeks">
                
                        <div style={{padding: '0.1em'}}><p>Post</p></div>
                        {
                            createWeeks(userPickset.postWeeks, true)
                        }
                </div> : null}
                
            </div>
            <div className="PickemPicksPage-weekView">
                <StatusBar/> 
            </div>

            
            {!isPickLoading && userPickset.currentWeek && !tiebreakDataLoading && !isSelectedLoading && !isSavingPicks && !hiddenEventsLoading && !headListLoading ? 
                <div>
                    <PickemPicksTable
                    subject="picks"
                    headList={headList}
                    list={userPickset.currentWeek}
                    selected={[]}
                    /> 
                    <Tiebreakers 
                        tiebreakData={tiebreakData}
                        tiebreakers={tiebreakers}
                        handleTiebreakerInput={handleTiebreakerInput}/>
                    
                    <div style={{ display: "flex", fontSize: "1em", margin: 0.5 }} className="PickemPicksPage-saveButtons">
                    <div className="PickemPicksPage-weekView">
                        <StatusBar/> 
                    </div>
                        <SaveButton />
                        <CancelButton />
                    </div>
                </div>
                : !errorLoadingPicks ? <Spinner></Spinner> : <NoResults
                label={"Error retrieving pickset"}
            />}
                </div>
            
        </PickemLayoutPage>
    );
};

export default withDialog(PickemPicksPage);
